/**
 * Media Query Component
 */

import * as React from 'react';
import MediaQuery, { MediaQueryProps } from 'react-responsive';

type AllowedMediaQueryProps =
  | 'className'
  | 'component'
  | 'style'
  | 'onBeforeChange'
  | 'onChange';

type MediaQueryComponent = React.ComponentType<Pick<MediaQueryProps, AllowedMediaQueryProps>>;

export const Phone: MediaQueryComponent = ({ children, ...props }) =>
  <MediaQuery minWidth={320} {...props}>{children}</MediaQuery>;

export const Phablet: MediaQueryComponent = ({ children, ...props }) =>
  <MediaQuery minWidth={480} {...props}>{children}</MediaQuery>;

export const TabletS: MediaQueryComponent = ({ children, ...props }) =>
  <MediaQuery minWidth={600} {...props}>{children}</MediaQuery>;

export const TabletM: MediaQueryComponent = ({ children, ...props }) =>
  <MediaQuery minWidth={768} {...props}>{children}</MediaQuery>;

export const TabletL: MediaQueryComponent = ({ children, ...props }) =>
  <MediaQuery minWidth={800} {...props}>{children}</MediaQuery>;

export const DesktopXS: MediaQueryComponent = ({ children, ...props }) =>
  <MediaQuery minWidth={864} {...props}>{children}</MediaQuery>;

export const DesktopS: MediaQueryComponent = ({ children, ...props }) =>
  <MediaQuery minWidth={960} {...props}>{children}</MediaQuery>;

export const Desktop: MediaQueryComponent = ({ children, ...props }) =>
  <MediaQuery minWidth={1024} {...props}>{children}</MediaQuery>;

export const DesktopM: MediaQueryComponent = ({ children, ...props }) =>
  <MediaQuery minWidth={1152} {...props}>{children}</MediaQuery>;

export const DesktopL: MediaQueryComponent = ({ children, ...props }) =>
  <MediaQuery minWidth={1280} {...props}>{children}</MediaQuery>;

export const DesktopXL: MediaQueryComponent = ({ children, ...props }) =>
  <MediaQuery minWidth={1440} {...props}>{children}</MediaQuery>;

export const DesktopXXL: MediaQueryComponent = ({ children, ...props }) =>
  <MediaQuery minWidth={1600} {...props}>{children}</MediaQuery>;

export const DesktopHD: MediaQueryComponent = ({ children, ...props }) =>
  <MediaQuery minWidth={1920} {...props}>{children}</MediaQuery>;

export const DesktopXHD: MediaQueryComponent = ({ children, ...props }) =>
  <MediaQuery minWidth={2160} {...props}>{children}</MediaQuery>;

export const DesktopQHD: MediaQueryComponent = ({ children, ...props }) =>
  <MediaQuery minWidth={2560} {...props}>{children}</MediaQuery>;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/mediaQueries/index.tsx